export enum TabIndex {
  COUNTRY = 0,
  PORTFOLIO = 1,
  POTENTIAL_PLATFORMS = 2,
  STEALTH_PLATFORMS = 3,
  FALSE_NEGATIVES = 4,
  VALIDATION = 5,
}
